module.exports = "<div class=\"wct-loading\">\n    <i class=\"fas fa-yin-yang\"></i>\n</div>"